import React from 'react'
import { useDispatch } from 'react-redux'
import { IconButton } from '@material-ui/core'
import { List } from '@material-ui/icons'
import { openDrawer } from 'actions'
import useStyles from './style'

const MenuButton = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  return (
    <IconButton
      className={classes.button}
      onClick={() => {
        dispatch(openDrawer())
      }}
    >
      <List fontSize="large" />
    </IconButton>
  )
}

export default MenuButton
